export default "__VITE_PUBLIC_ASSET__ac853b0f__"